import { ParticipationState } from '../../models/loyalty/participation.state';
import {
  LOYALTY_APPROVE,
  LOYALTY_APPROVE_SUCCESS,
  LOYALTY_APPROVE_ERROR,
  LOYALTY_REQUEST,
  LOYALTY_REQUEST_SUCCESS,
  LOYALTY_REQUEST_ERROR,
  ParticipationActions
} from '../../actions/loyalty/actions-participation';

/* eslint-disable */
function getInitialState(): ParticipationState {
  return {
    isApprove: false,
    isRequest: false,
    isLoading: false,
    loadingError: ''
  };
}

const initialState: ParticipationState = getInitialState();

/* eslint-disable */
export function reducersParticipation(state = initialState, action: ParticipationActions): ParticipationState {
  switch (action.type) {
    case LOYALTY_APPROVE:
      return { ...state, isLoading: true, loadingError: '' };

    case LOYALTY_APPROVE_SUCCESS:
      return { ...state, isApprove: action.payload, isLoading: false, loadingError: '' };

    case LOYALTY_APPROVE_ERROR:
      return { ...state, isLoading: false, loadingError: action.payload };

    case LOYALTY_REQUEST:
      return { ...state, isLoading: true, loadingError: '' };

    case LOYALTY_REQUEST_SUCCESS:
      return { ...state, isRequest: action.payload, isLoading: false, loadingError: '' };

    case LOYALTY_REQUEST_ERROR:
      return { ...state, isLoading: false, loadingError: action.payload };

    default:
      return getInitialState();
  }
}
